import mainTheme from './main';

export { default as whitespace } from './whitespace';

export const main = mainTheme;
export type Theme = typeof main;
export type ThemeColors = keyof typeof main.colors;
